/* Frequently bought together — display-only block; variant dropdowns swap price, image + link. */
if (!customElements.get('tsdc-fbt')) {
  customElements.define(
    'tsdc-fbt',
    class TsdcFbt extends HTMLElement {
      connectedCallback() {
        this.recs = this.querySelector('product-recommendations');
        this.moneyFormat = this.dataset.moneyFormat || '₹ {{amount}}';

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-fbt-select]')) this.onVariantSelect(event.target);
        });

        // Recommendations arrive asynchronously (product-recommendations swaps its innerHTML).
        new MutationObserver(() => this.onRecsChanged()).observe(this.recs, { childList: true });
        this.onRecsChanged();
        // The block starts hidden, so Dawn's IntersectionObserver would never fire — fetch directly.
        customElements.whenDefined('product-recommendations').then(() => {
          this.recs.observer?.disconnect();
          this.recs.loadRecommendations?.(this.recs.dataset.productId);
        });
      }

      // Variant dropdown on a recommended product: swap its price, image and "View product" link.
      onVariantSelect(select) {
        const item = select.closest('.tsdc-fbt__item');
        const option = select.selectedOptions[0];
        if (!item || !option) return;
        const price = item.querySelector('[data-fbt-price]');
        if (price) price.textContent = this.money(Number(option.dataset.price || 0));
        const img = item.querySelector('.tsdc-fbt__media img');
        if (img && option.dataset.image) {
          img.src = option.dataset.image;
          img.removeAttribute('srcset');
        }
        const link = item.querySelector('[data-fbt-link]');
        if (link) link.href = `${link.dataset.url}?variant=${option.value}`;
      }

      onRecsChanged() {
        this.hidden = !this.recs.querySelector('.tsdc-fbt__item');
      }

      money(cents) {
        const amount = cents / 100;
        const noDecimals = /no_decimals/.test(this.moneyFormat);
        const formatted = amount.toLocaleString('en-IN', {
          minimumFractionDigits: noDecimals ? 0 : 2,
          maximumFractionDigits: noDecimals ? 0 : 2,
        });
        return this.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, formatted).replace(/<[^>]+>/g, '').trim();
      }
    }
  );
}
